module.exports = __webpack_public_path__ + "img/Miguel-Angel-Osuna.b7f01d51.png";